import React from 'react';
import { RewardFormValues, RewardFormViolation } from 'types/rewardFormTypes';
import { isRewardFormViolation } from 'utils/rewardFormUtils';
import { stringIsEmpty, stringIsUSDAmount } from 'utils/stringUtils';

export const useRewardForm = (initialValues: RewardFormValues) => {
  const [values, setValues] = React.useState<RewardFormValues>(initialValues);

  const [violations, setViolations] = React.useState<RewardFormViolation[]>([]);

  const setAmountValue = React.useCallback((nextValue: string) => {
    if (stringIsEmpty(nextValue) || stringIsUSDAmount(nextValue)) {
      setValues((prev) => ({ ...prev, amount: nextValue }));

      setViolations((prev) =>
        prev.filter(
          (violation) => !isRewardFormViolation(violation).isAmountViolation()
        )
      );
    }
  }, []);

  const setCommentValue = React.useCallback((nextValue: string) => {
    setValues((prev) => ({ ...prev, comment: nextValue }));

    setViolations((prev) =>
      prev.filter(
        (violation) => !isRewardFormViolation(violation).isCommentViolation()
      )
    );
  }, []);

  return {
    values,
    violations,
    setValues,
    setViolations,
    setAmountValue,
    setCommentValue,
  };
};
